module.exports = __webpack_public_path__ + "static/img/aqzs52.cdd0ddc7.jpg";